/* eslint-disable import/no-cycle */
import { Model } from '@vuex-orm/core';

export default class UserRole extends Model {
  static entity = 'userRoles'

  static fields() {
    return {
      id: this.attr(''),
      userId: this.attr(''),
      roleId: this.attr(''),
      hidePii: this.attr(false),
      hideMenuManagement: this.attr(false)
    };
  }

  // STATE //////////////////////
  static $state() {
    return this.store().state.entities.userRoles;
  }
}
